import Route from '@ember/routing/route';

export default class AuthenticatedPslfDashboardForgivenessEstimatorResultsNextStepsRoute extends Route {
  model() {
    return this.modelFor('authenticated.pslf.dashboard.forgiveness-estimator.results');
  }
}
